import { type ReactNode, createContext, useContext } from 'react';

/**
 * Share-scoped download config for public share pages. Provided by the public
 * gallery layout (only when the share allows downloads) and consumed by the
 * gallery item context menu so guest/authenticated viewers get a download-only
 * right-click action (anonymous viewers never see it — gated on
 * canDownloadAssets at the call site) — without threading a share-specific
 * prop through the generic DataTable components. `null` means downloads
 * aren't available.
 */
export type ShareDownloadConfig = {
  shareId: string;
  downloadableVariants: Array<{ id: string; name: string; slug: string }>;
  name?: string;
  includeOriginalFile?: boolean;
};

const ShareDownloadContext = createContext<ShareDownloadConfig | null>(null);

export const ShareDownloadProvider = ({
  value,
  children,
}: {
  value: ShareDownloadConfig | null;
  children: ReactNode;
}) => <ShareDownloadContext.Provider value={value}>{children}</ShareDownloadContext.Provider>;

export const useShareDownload = () => useContext(ShareDownloadContext);
